import { render, staticRenderFns } from "./TestLiverateModal.vue?vue&type=template&id=098d8156&scoped=true"
import script from "./TestLiverateModal.vue?vue&type=script&lang=js"
export * from "./TestLiverateModal.vue?vue&type=script&lang=js"
import style0 from "./TestLiverateModal.vue?vue&type=style&index=0&id=098d8156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098d8156",
  null
  
)

export default component.exports